// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"213":"d1dd19a9","239":"f9668066","453":"f99839ff","667":"ce1b79cb"}[chunkId] + ".chunk.js";
};